import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "file-display"
}
const _hoisted_2 = { class: "img-box" }
const _hoisted_3 = { class: "menu-bar" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "file" }
const _hoisted_6 = { class: "des" }

import {
  showUserServiceDialogue,
  showVIPDialogue,
} from "@/components/Dialogues/useData/useDialogues";
import { sendMsg, setType } from "@/views/Home/useData/module/chat";
import { ref, reactive, computed, Reactive, watch } from "vue";
import { ElMessage } from "element-plus";
import { chatStatus } from "@/views/Home/useData/module/chat";
import { isCompactMode } from "@/data/pubilc";
import {
  uploadCurFile,
  inputForm,
} from "@/components/Dialogues/useData/useInputBar";
import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import { openLoginDialog } from "@/components/Dialogues/useData/login";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatInputBar',
  setup(__props) {

const { isLogin, isVip } = storeToRefs(publicStore());

const isReplying = computed(() => {
  return chatStatus.isReplying;
});

const preSendMsg = async () => {
  if (isUploadingFile.value) {
    ElMessage.warning("请等待文件上传完毕");
    return;
  }
  inputForm.inputValue = inputForm.inputValue.trim();
  const text = inputForm.inputValue;
  if (text === "") {
    ElMessage.warning("请输入内容");
    return;
  }

  if (isReplying.value) {
    return;
  }

  if (!isLogin.value) {
    ElMessage.warning("请登录后使用");

    openLoginDialog();
    return;
  }

  if (!isVip.value) {
    showVIPDialogue.value = true;
    return;
  }

  //检查类型
  const type = inputForm.r1 ? "R1" : "deep-seek-v3";
  setType(type);

  let options = {
    chatOption: {
      use_internet: inputForm.network,
    },
  };

  if (inputForm.network) {
    options.chatOption["auto_user_want"] = true;
    options.chatOption["user_want"] = 1;
  }

  if (referenceFile.fileUrl) {
    options = {
      use_internet: inputForm.network,
      url: referenceFile.fileUrl,
      fileInfo: {
        url: referenceFile.fileUrl,
        name: referenceFile.fileName,
      },
      chatOption: {
        user_want: 8,
      },
    };
  }

  await sendMsg(text, options);

  inputForm.inputValue = "";
  clearFile();
};

const referenceFile: Reactive<any> = reactive({
  fileUrl: "",
  fileName: "",
});

const isUploadingFile = ref(false);

const onChange = async (data: any) => {
  if (data.status !== "ready") return;
  if (!isLogin.value) {
    ElMessage.warning("请登录后使用");
    openLoginDialog();
    return;
  }
  isUploadingFile.value = true;
  console.log("Received data", data);
  const rawFile: any = data.raw;
  const typeList = ["image/jpg", "image/png", "image/jpeg"];
  if (!typeList.includes(rawFile.type))
    return ElMessage.error("只支持jpg/png文件格式");
  else if (rawFile.size / 1024 / 1024 > 10)
    return ElMessage.error(`文件大小不能超过10MB!`);
  let url = URL.createObjectURL(rawFile);

  const fileInfo = {
    file: rawFile,
    name: rawFile.name,
    size: rawFile.size,
  };
  fileInfo.file["path"] = url;
  const res: any = await uploadCurFile(fileInfo);
  referenceFile.fileUrl = res;
  referenceFile.fileName = fileInfo.name;
  isUploadingFile.value = false;
};

const clearFile = () => {
  referenceFile.fileUrl = "";
  referenceFile.fileName = "";
  isUploadingFile.value = false;
};

const changeToR1 = () => {
  inputForm.r1 = !inputForm.r1;
  clearFile();
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Paperclip = _resolveComponent("Paperclip")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Top = _resolveComponent("Top")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["input-base", {
      'file-content': referenceFile.fileUrl,
    }])
    }, [
      (referenceFile.fileUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_image, {
                style: {"width":"60px","height":"60px"},
                src: referenceFile.fileUrl,
                fit: "cover"
              }, null, 8, ["src"]),
              _createElementVNode("div", {
                class: "close-btn",
                onClick: clearFile
              }, [
                _createVNode(_component_el_icon, { size: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CircleCloseFilled)
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(inputForm).inputValue) = $event)),
        class: "text-area",
        name: "",
        id: "",
        rows: "10",
        onKeyup: _withKeys(preSendMsg, ["enter"]),
        placeholder: "在这里输入您的问题开始和AI对话"
      }, null, 544), [
        [_vModelText, _unref(inputForm).inputValue]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["left", {
          'compact-gap': _unref(isCompactMode),
        }])
        }, [
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "调用新模型DeepSeek-R1，解决推理问题",
            placement: "left",
            disabled: _unref(isCompactMode)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["btn", { 'dis-selected': !_unref(inputForm).r1 }]),
                onClick: changeToR1
              }, " 深度思考(R1) ", 2)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "按需搜索网页",
            placement: "right",
            disabled: _unref(isCompactMode)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["btn", { 'dis-selected': !_unref(inputForm).network }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(inputForm).network = !_unref(inputForm).network))
              }, " 互联网搜索 ", 2)
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 2),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_upload, {
            "show-file-list": false,
            "auto-upload": false,
            "on-change": onChange,
            accept: ".png,.jpg,.jpeg"
          }, {
            default: _withCtx(() => [
              (!_unref(inputForm).r1)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    class: "box-item",
                    effect: "dark",
                    content: "上传图片，仅识别文字",
                    placement: "bottom",
                    disabled: _unref(isCompactMode)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_el_icon, {
                          color: `black`,
                          size: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Paperclip)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "提交",
            placement: "right",
            disabled: _unref(isCompactMode)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "send-btn",
                onClick: preSendMsg
              }, [
                _createVNode(_component_el_icon, {
                  color: `white`,
                  size: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Top)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_6, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text" }, "内容由 AI 生成，请仔细甄别", -1)),
      _createElementVNode("div", {
        class: "text btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (showUserServiceDialogue.value = true))
      }, "关于我们")
    ])
  ], 64))
}
}

})